import { motion } from 'framer-motion';
import { Search, Database, ShieldCheck, Lock, Settings } from 'lucide-react';
import UseCase from '../components/UseCases/UseCase';
import HeroSection from '../components/HeroSection';

const useCases = [
  {
    title: "Data Discovery",
    description: "Gain complete visibility into cloud data stores and identities. Our advanced scanning technology helps you identify and catalog sensitive data across your entire infrastructure.",
    features: [
      "Automated data source discovery across cloud and on-premises",
      "Real-time data mapping and classification",
      "Sensitive data identification and tracking"
    ],
    benefits: "Reduce risk by identifying unknown data sources and maintain a comprehensive data inventory automatically.",
    icon: Search
  },
  {
    title: "Data Classification",
    description: "Categorize and label data based on its sensitivity and compliance requirements. Automatically classify data using AI-powered algorithms to ensure proper handling and protection.",
    features: [
      "AI-powered data classification engine",
      "Custom classification rules and policies",
      "Automated metadata tagging and labeling"
    ],
    benefits: "Ensure consistent data handling and streamline compliance processes with intelligent classification.",
    icon: Database
  },
  {
    title: "Data Detection and Response",
    description: "Proactively identify and mitigate data security threats. Implement real-time monitoring and automated response mechanisms to protect sensitive information.",
    features: [
      "Real-time threat detection and response",
      "Automated security policy enforcement",
      "Incident response automation and workflows"
    ],
    benefits: "Minimize data breach risks and reduce incident response time with automated protection measures.",
    icon: Lock
  },
  {
    title: "Data Compliance",
    description: "Stay compliant with industry regulations and internal policies. Our platform helps you meet requirements for GDPR, HIPAA, CCPA, and other regulatory frameworks.",
    features: [
      "Pre-built compliance templates and frameworks",
      "Continuous compliance monitoring and alerts",
      "Automated compliance reporting and documentation"
    ],
    benefits: "Maintain regulatory compliance effortlessly and reduce audit preparation time by up to 70%.",
    icon: ShieldCheck
  },
  {
    title: "Data Governance",
    description: "Enforce governance policies, manage access permissions, and track data usage. Maintain complete control over your data with comprehensive audit trails and reporting.",
    features: [
      "Centralized policy management",
      "Role-based access control (RBAC)",
      "Data lifecycle management automation"
    ],
    benefits: "Strengthen data governance while reducing administrative overhead through automation.",
    icon: Settings
  }
  
  
];

const UseCases = () => {
  return (
    <div className="min-h-screen">
      <HeroSection 
        title="Unlock the Potential of your Data" 
        subtitle="Integrated suite of use cases ensuring compliance with regulations and
              safeguarding against security threats."
        hideImage={true}
      />
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
        <div className="container mx-auto px-4 py-16">
          {/* Header Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto mb-16"
          >
          </motion.div>

          {/* Use Cases Grid */}
          <div className="grid grid-cols-1 gap-8 max-w-5xl mx-auto">
            {useCases.map((useCase, index) => (
              <UseCase
                key={useCase.title}
                title={useCase.title}
                description={useCase.description}
                features={useCase.features}
                benefits={useCase.benefits}
                icon={useCase.icon}
                index={index}
              />
            ))}
          </div>

          {/* CTA Section */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
            className="text-center mt-16"
          >
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default UseCases; 